import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * Hubspot Logo component
 *
 * @returns JSX.ELEMENT
 */
export const HubspotLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 242 257" data-testid={dataTestId}>
      <path
        fill="#ff7a59"
        d="M182,109.4c-5.6-4.3-12.2-7.1-19.2-8.2h0V82c5.2-2.4,8.5-7.6,8.6-13.4v-0.5c0-8.2-6.6-14.8-14.8-14.8h-0.5c-8.2,0-14.8,6.6-14.8,14.8v0.5c0,5.7,3.4,11,8.6,13.4v19.3c-7.3,1.1-14.2,4.2-20,8.8L76.9,68.9c2.4-9-2.9-18.3-12-20.7c-9-2.4-18.3,2.9-20.7,12c-2.4,9,2.9,18.3,12,20.7c4.3,1.2,8.9,0.6,12.8-1.7l52,40.5c-9.6,14.5-9.3,33.4,0.7,47.6l-15.8,15.8c-1.3-0.4-2.6-0.6-3.9-0.6c-7.6,0-13.8,6.2-13.8,13.8s6.2,13.8,13.8,13.8s13.8-6.2,13.8-13.8c0-1.3-0.2-2.7-0.6-3.9l15.7-15.7c18.5,14.2,45.1,10.6,59.2-7.9C204,150.1,200.5,123.6,182,109.4z M156.3,164.7L156.3,164.7c-12,0-21.7-9.8-21.7-21.7c0-12,9.8-21.7,21.7-21.6c12,0,21.6,9.7,21.6,21.7C178,155,168.3,164.7,156.3,164.7z"
      />
    </svg>
  );
};
